import { Direction } from './direction.js'
import { Bridge } from 'dolphin-native-bridge'

export class Touch {
  static MIN_DISTANCE = 10

  static Create() {
    return new Touch()
  }

  constructor() {
    this.startX = 0
    this.startY = 0
    this.startX = 0
    this.moveStartX = 0
    this.moveStartY = 0
    this.deltaX = 0
    this.deltaY = 0
    this.isIos = weex.config.env.platform == 'iOS' ? true : false
    this.envConfig = weex.config.env
    this.systemInfo = null
    Bridge.getSystemInfo()
      .then(res => {
        this.systemInfo = res
      })
      .catch(err => {
        // this.$toast(err)
      })

    this.direction = Direction.NONE
  }

  get offsetX() {
    return Math.abs(this.deltaX)
  }

  get offsetY() {
    return Math.abs(this.deltaY)
  }

  get isHorizental() {
    return this.direction === Direction.HOR
  }

  get isVertical() {
    return this.direction === Direction.VER
  }

  get isUndetermined() {
    return this.direction === Direction.NONE
  }

  resolveDirection(x, y) {
    if (x > y && x > Touch.MIN_DISTANCE) {
      return Direction.HOR
    }
    if (y > x && y > Touch.MIN_DISTANCE) {
      return Direction.VER
    }
    return Direction.NONE
  }

  reset() {
    this.startX = 0
    this.startY = 0
    this.moveStartX = 0
    this.moveStartY = 0
    this.deltaX = 0
    this.deltaY = 0
    this.direction = Direction.NONE
  }

  getTouchByEvent(e) {
    return e.changedTouches[0]
  }

  start(evt) {
    const e = this.getTouchByEvent(evt)
    this.reset()
    // screenX	触摸点相对于屏幕左侧边缘的 X 轴坐标
    // pageX	触摸点相对于文档左侧边缘的 X 轴坐标
    this.moveStartX = e.screenX
    this.moveStartY = e.screenY
    // 判断为折叠机
    let isFoldAble = this.systemInfo.screenWidth > this.envConfig.deviceWidth? true : false
    // 是否iPad
    const isIPad = WXEnvironment && WXEnvironment.deviceModel.indexOf('iPad') === 0

    // ios或正常屏机型，保持位移X用screenX
    // 折叠机展开则用计算出实际x坐标大小
    this.startX = isIPad ? e.pageX : (this.isIos || !isFoldAble)?e.screenX : e.screenX - (((this.systemInfo.screenWidth - this.envConfig.deviceWidth)/ this.envConfig.scale ))
    this.startY = e.screenY
  }

  move(evt) {
    const e = this.getTouchByEvent(evt)
    this.deltaX = e.screenX - this.moveStartX
    this.deltaY = e.screenY - this.moveStartY
    if (this.isUndetermined) {
      this.direction = this.resolveDirection(this.offsetX, this.offsetY)
    }
  }

}



// WEBPACK FOOTER //
// ./packages/utils/touch.js